"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var address_value_1 = require("./../../../shared/model/address-value");
var router_1 = require("@angular/router");
var address_1 = require("../../../shared/model/address");
var phone_pipe_1 = require("../../../shared/pipe/phone.pipe");
var cep_pipe_1 = require("../../../shared/pipe/cep.pipe");
var branch_1 = require("../../../shared/model/branch");
var management_contact_1 = require("../../../shared/model/management-contact");
var branch_service_1 = require("../../../shared/service/branch.service");
var customer_service_1 = require("../../../shared/service/customer.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var BranchCreateUpdateComponent = /** @class */ (function () {
    function BranchCreateUpdateComponent(_branchService, _customerService, _route, _router, _toastService) {
        this._branchService = _branchService;
        this._customerService = _customerService;
        this._route = _route;
        this._router = _router;
        this._toastService = _toastService;
        this.customerAttributesTree = ['name'];
        this.editMode = false;
        this.setEmptyEntities();
        this.setPipes();
        this.editModeVerify();
        this.setUpObservers();
    }
    BranchCreateUpdateComponent.prototype.ngOnInit = function () {
    };
    BranchCreateUpdateComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    BranchCreateUpdateComponent.prototype.save = function () {
        this.sanitizeBranch();
        if (!this.newBranch.address.number || !this.newBranch.address.number.trim()) {
            this.newBranch.address.number = address_value_1.AddressValue.WITHOUT_NUMBER;
        }
        if (this.editMode) {
            this._branchService.update(this.newBranch);
        }
        else {
            this._branchService.save(this.newBranch);
        }
    };
    BranchCreateUpdateComponent.prototype.findCustomer = function (name) {
        this._customerService.findByName(name);
    };
    BranchCreateUpdateComponent.prototype.editModeVerify = function () {
        var _this = this;
        this.partialTitle = 'Cadastrar ';
        this._route.params.subscribe(function (params) {
            if (params['id']) {
                _this.editMode = true;
                _this.branchId = +params['id'];
                _this._branchService.findById(_this.branchId);
                _this.partialTitle = 'Editar ';
            }
        });
    };
    BranchCreateUpdateComponent.prototype.updateIntegrationValue = function () {
        this.newBranch.needIntegration = !this.newBranch.needIntegration;
    };
    BranchCreateUpdateComponent.prototype.sanitizeBranch = function () {
        var emptyBranch = { address: {} };
        var isEmpty = JSON.stringify(this.newBranch.managementContact) === JSON.stringify(emptyBranch);
        if (isEmpty) {
            this.newBranch.managementContact = null;
        }
        if (!this.newBranch.needIntegration) {
            this.newBranch.needIntegration = false;
        }
    };
    BranchCreateUpdateComponent.prototype.setUpObservers = function () {
        this.setUpFindAction(this._branchService.find$);
        this.setUpSaveUpdateAction(this._branchService.save$);
        this.setUpSaveUpdateAction(this._branchService.update$);
        this.setUpErrorAction(this._branchService.error$);
        this.setUpFindCustomers(this._customerService.find$);
    };
    BranchCreateUpdateComponent.prototype.setUpFindAction = function (observable) {
        var _this = this;
        observable
            .filter(function (branch) { return branch instanceof branch_1.Branch; })
            .subscribe(function (branch) {
            _this.newBranch = branch;
            if (!_this.newBranch.managementContact) {
                _this.setEmptyManagementContact();
            }
        });
    };
    BranchCreateUpdateComponent.prototype.setUpErrorAction = function (observable) {
        var _this = this;
        observable
            .subscribe(function (error) { return _this.showMessage(error.text); });
    };
    BranchCreateUpdateComponent.prototype.setUpSaveUpdateAction = function (observable) {
        var _this = this;
        observable
            .subscribe(function () {
            _this.goBack();
        });
    };
    BranchCreateUpdateComponent.prototype.setUpFindCustomers = function (observable) {
        var _this = this;
        observable
            .filter(function (customers) { return customers instanceof Array; })
            .subscribe(function (customers) { return _this.customers = customers; });
    };
    BranchCreateUpdateComponent.prototype.setPipes = function () {
        this.phonePipe = new phone_pipe_1.PhonePipe();
        this.cepPipe = new cep_pipe_1.CepPipe();
    };
    BranchCreateUpdateComponent.prototype.setEmptyEntities = function () {
        this.newBranch = new branch_1.Branch();
        this.newBranch.address = new address_1.Address();
        this.customers = new Array();
        this.setEmptyManagementContact();
    };
    BranchCreateUpdateComponent.prototype.setEmptyManagementContact = function () {
        this.newBranch.managementContact = new management_contact_1.ManagementContact();
        this.newBranch.managementContact.address = new address_1.Address();
    };
    BranchCreateUpdateComponent.prototype.applyPhoneMask = function (event) {
        this.newBranch.managementContact.phone = this.phonePipe.transform(event.target.value, event.key);
    };
    BranchCreateUpdateComponent.prototype.applyCepMask = function (event) {
        return this.cepPipe.transform(event.target.value, event.key);
    };
    BranchCreateUpdateComponent.prototype.goBack = function () {
        this._router.navigate(['branches/list']);
    };
    BranchCreateUpdateComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    BranchCreateUpdateComponent.ctorParameters = function () { return [{ type: branch_service_1.BranchService }, { type: customer_service_1.CustomerService }, { type: router_1.ActivatedRoute }, { type: router_1.Router }, { type: toast_service_1.ToastService }]; };
    return BranchCreateUpdateComponent;
}());
exports.BranchCreateUpdateComponent = BranchCreateUpdateComponent;
//# sourceMappingURL=branch-create-update.component.js.map


// WEBPACK FOOTER //
// branch-create-update.component.js